// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget__status-detail{width:100%;height:100%;min-height:32px;display:flex;flex-direction:column;overflow-x:hidden;overflow-y:hidden;color:#fff;background:#00183d;background:linear-gradient(180deg, #00183D, #000e24)}.widget__status-detail.widget__status-detail--scroll{overflow-y:auto}.widget__status-detail .widget-status-detail__group-title{padding:8px;color:#aeb2b7}.widget__status-detail .empty-message{font-size:21px;font-style:italic;padding:8px;color:#787f87}", ""]);
// Exports
module.exports = exports;
